import { number, object, SchemaOf, date } from 'yup';
import dayjs from 'dayjs';

import { MUST_NOT_BE_ZERO_WHEN_ROUNDED, REQUIRED_FIELD } from '@/config/text.const';


export type Fields = {
  value?: number | null;
  validThrough?: Date | null;
};

export const validationSchema: SchemaOf<Fields> = object().shape({
  value: number()
    .test((value, context) => {
      const isValueRequired = context.parent.upliftTypeId?.isValueRequired;
      if (!value && isValueRequired) {
        return context.createError({
          path: 'value',
          message: REQUIRED_FIELD
        });
      }

      if (isValueRequired && +((value ?? 0).toFixed(2)) == 0) {
        return context.createError({
          path: 'value',
          message: MUST_NOT_BE_ZERO_WHEN_ROUNDED
        });
      }

      return true;
    })
    .nullable(),
  validThrough: date()
    .test((value, context) => {
      const contractStartDate = context.parent.contractStartDate;
      if (value && (dayjs(value).isBefore(dayjs(contractStartDate), 'date') ||
        dayjs(value).isSame(dayjs(contractStartDate), 'date'))) {
        return context.createError({
          path: 'validThrough',
          message: 'Valid Until Date should be after Contract Start Date'
        });
      }
      return true;
    })
    .nullable(),
});
